module.exports = __webpack_public_path__ + "static/img/0.6aae3777.png";